<template>
  <div class="custom-content-list">
    <div
      v-for="(content, contentIndex) in customContentList"
      class="custom-content"
      :style="getCustomStyle(content, contentIndex)"
      :key="contentIndex"
    >
      <!-- 文本 -->
      <template v-if="content.type === CUSTOM_CONTENT_TYPE.TEXT">
        <div class="text-previewer">
          <div v-if="content.title" class="title">{{ content.title }}</div>
          <TextEllipsis
            v-for="(item, index) in content.items"
            class="text"
            isMultiFunctionText
            :key="index"
            :height="300"
            :text="item.text"
          ></TextEllipsis>
        </div>
      </template>
      <!-- 轮播图 -->
      <template v-if="content.type === CUSTOM_CONTENT_TYPE.CAROUSEL">
        <div class="carousel-previewer">
          <div v-if="content.title" class="title">{{ content.title }}</div>
          <van-swipe class="swiper-container" indicator-color="#7d7d7d" :ref="`swipe_${contentIndex}`" :autoplay="3000" :duration="2000">
            <van-swipe-item v-for="(item, index) in content.items" class="swiper-item" :key="index" @mousedown.native.stop="onMouseDown($event, contentIndex, item)">
              <div class="carousel-img-wrapper" :style="{ height: carouselHeightMap[`content_${contentIndex}`] }">
                <img class="carousel" :ref="`carouselImg_${contentIndex}`" :src="getFilePath(item.resource_key)" @click="handleImgClick(item, true)" @load="onCarouselLoaded(contentIndex)" />
              </div>
              <div v-if="item.description" class="carousel-description">{{ item.description }}</div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </template>
      <!-- 组合图 -->
      <template v-if="content.type === CUSTOM_CONTENT_TYPE.PICTURE">
        <div class="picture-previewer">
          <div v-if="content.title" class="title">{{ content.title }}</div>
          <div class="picture-list" :class="`picture-${content.items.length}`">
            <div v-for="(item, index) in content.items" class="picture-item" :key="index">
              <div class="picture-wrapper">
                <img class="picture" :src="getFilePath(item.resource_key)" @click="handleImgClick(item)">
              </div>
              <div v-if="item.description" class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 视频 -->
      <template v-if="content.type === CUSTOM_CONTENT_TYPE.VIDEO">
        <div class="video-previewer">
          <div v-if="content.title" class="title">{{ content.title }}</div>
          <div v-for="(item, index) in content.items" class="video-wrapper" :key="index">
            <VideoPlayer class="player" :videoSrc="getFilePath(item.resource_key)" :posterSrc="getFilePath(item.cover_resource_key)"></VideoPlayer>
            <TextEllipsis v-if="item.description" class="video-desc" :lineHeight="25" :rows="3" :text="item.description"></TextEllipsis>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getFilePath } from '@/utils/qiniu'
import TextEllipsis from './textEllipsis.vue'
import VideoPlayer from './videoPlayer.vue'
import _ from 'lodash'
import { SwipeAdapter } from '@/plugins/vant'
import { deviceType } from '@/utils/common'

const CUSTOM_CONTENT_TYPE = {
  VIDEO: 'video',
  CAROUSEL: 'silder',
  TEXT: 'text',
  PICTURE: 'picture'
}

export default {
  components: {
    TextEllipsis,
    VideoPlayer
  },
  props: {
    customContentList: {
      type: Array
    },
    showGap: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      CUSTOM_CONTENT_TYPE,
      carouselHeightMap: {},
      swipeAdapter: {}
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getFilePath,
    handleImgClick (item, isCarouse, isAdapter) {
      if (!item.target_url) {
        return
      }
      if (isCarouse && deviceType.isPc) {
        if (!isAdapter) {
          return
        }
      }
      window.open(item.target_url.startsWith('http') ? item.target_url : 'http://' + item.target_url.trim())
    },
    onCarouselLoaded (contentIndex) {
      const carouselElList = this.$refs[`carouselImg_${contentIndex}`]
      let height = 0
      _.forEach(carouselElList, (carouselEl, index) => {
        height = height > carouselEl.offsetHeight ? height : carouselEl.offsetHeight
      })
      this.$set(this.carouselHeightMap, `content_${contentIndex}`, `${height}px`)
    },
    onMouseDown (e, contentIndex, item) {
      const swipeId = `swipe_${contentIndex}`
      if (!this.swipeAdapter[swipeId]) {
        const swiper = this.$refs[swipeId][0]
        _.forEach(swiper.$el.querySelectorAll('img'), image => {
          image.draggable = false
        })
        this.swipeAdapter[swipeId] = new SwipeAdapter(swiper, this.onMouseClick)
      }
      this.swipeAdapter[swipeId].onMouseDown(e, item, true, true)
    },
    onMouseClick (e, item, isCarouse, isAdapter) {
      this.handleImgClick(item, isCarouse, isAdapter)
    },
    getCustomStyle (content, contentIndex) {
      return {
        marginTop: (this.showGap || contentIndex === 0) ? '15px' : '0',
        padding: content.hiddenPadding ? '0' : '15px'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-content-list {
  background-color: #f7f7f7;
  ::v-deep {
    ul, ol {
      margin: 0;
      padding-left: 20px !important;
      list-style-type: disc;
    }
    ol {
      list-style-type: decimal;
    }
  }

  .custom-content {
    background: #fff;
    padding: 15px;

    .title {
      font-size: 16px;
      color: #333;
      margin-bottom: 15px;
    }

    .text-previewer {
      .text {
        color: #888;
        font-size: 14px;
        line-height: 25px;
      }
    }

    .carousel-previewer {

      ::v-deep {
        .van-swipe__indicators {
          .van-swipe__indicator {
            width: 8px;
            height: 8px;
            background-color: rgba($color: #000, $alpha: 0.2);
          }
        }
      }

      .swiper-container {
        max-height: calc(100vh - 50px);

        .swiper-item {
          height: 100%;
          .carousel-img-wrapper {
            max-width: 100%;
            max-height: calc(100vh - 50px);
            display: flex;
            align-items: center;
            justify-content: center;

            .carousel {
              max-width: 100%;
              max-height: 100%;
              object-fit: cover;
            }
          }

          .carousel-description {
            color: #888;
            margin-top: 8px;
            margin-bottom: 25px;
            padding: 0 2px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .picture-previewer {
      .picture-list {
        display: flex;

        &.picture-1 {
          .picture-item {
            .description {
              font-size: 14px;
              line-height: 25px;
            }
          }
        }

        &.picture-3 {
          .picture-item {
            .picture-wrapper {
              width: 80%;
              height: 96px;
            }
          }
        }

        .picture-item {
          flex: 1;

          .picture-wrapper {
            width: 100%;
            height: 140px;
            margin: 0 auto;
            text-align: center;

            .picture {
              max-width: 100%;
              max-height: 100%;
            }
          }

          .description {
            color: #888;
            font-size: 10px;
            line-height: 15px;
            margin: 2px auto;
            margin-top: 8px;
            width: 80%;
          }
        }
      }
    }

    .video-previewer {
      background-color: #fff;

      .video-wrapper {
        width: 100%;

        .video-desc {
          color: #888;
          font-size: 14px;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    .custom-content {
      .picture-previewer {
        .picture-list {
          .picture-item {
            .picture-wrapper {
              height: 355px;
            }
          }
        }
      }
    }
  }
}
</style>
